import React from 'react';

import {
  useLoading,
  validationUtil
} from 'modules/layer0';

import {
  useEditAccessPassModalLazyQuery, useSaveAccessPassMutation
} from 'generated/graphql';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import moment from 'moment';



const __formSchema = yup.object({
  email: validationUtil.emailSchema.required(),
  note: validationUtil.nonEmptyStringSchema.required(),
  startDate: validationUtil.dateSchema.required(),
  endDate: validationUtil.dateSchema.required()
}).required();

export type IFormState = yup.InferType<typeof __formSchema>;



export function useQuery(accessPassId?: string) {
  const [fnQuery, tuple] = useEditAccessPassModalLazyQuery({
    fetchPolicy: 'network-only'
  });
  const [saveAccessPass, saveAccessPassTuple] = __useSaveAccessPass(accessPassId);
  const loading = useLoading([
    tuple,
    saveAccessPassTuple
  ]);

  const form = useForm<IFormState>({
    resolver: yupResolver(__formSchema),
    shouldFocusError: true,
    defaultValues: {
      email: '',
      note: ''
    }
  });



  React.useEffect(() => {
    if (accessPassId) {
      fnQuery({ variables: { accessPassId } });
    }
  }, [
    accessPassId,
    fnQuery
  ]);

  const defaultValues = React.useMemo((): IFormState => ({
    email: tuple.data?.accessPass?.email ?? '',
    note: tuple.data?.accessPass?.note ?? '',
    startDate: tuple.data?.accessPass?.startDate ?
      moment(tuple.data?.accessPass?.startDate).startOf('day').toDate() :
      moment().startOf('day').toDate(),
    endDate: tuple.data?.accessPass?.endDate ?
      moment(tuple.data?.accessPass?.endDate).endOf('day').toDate() :
      moment().endOf('day').toDate()
  }), [tuple]);

  React.useEffect(() => {
    form.reset(defaultValues);
  }, [
    form,
    defaultValues
  ]);



  return {
    form,
    loading,
    mutations: {
      saveAccessPass
    }
  };
}



function __useSaveAccessPass(accessPassId?: string) {
  const [fnMutate, tuple] = useSaveAccessPassMutation({});



  const wrappedMutate = React.useCallback(async (formState: IFormState) => {
    await fnMutate({
      variables: {
        input: {
          id: accessPassId,
          email: formState.email,
          note: formState.note,
          startDate: moment(formState.startDate).toISOString(),
          endDate: moment(formState.endDate).toISOString()
        }
      }
    });

  }, [
    accessPassId,
    fnMutate
  ]);

  const wrappedTuple = React.useMemo(() => ({
    ...tuple,
    data: null
  }), [tuple]);



  return [
    wrappedMutate,
    wrappedTuple
  ] as const;
}
